import { Grid } from '@mui/material';
import { FC } from 'react';

import { FormSectionTitleTypes } from '../../enums';

import { Title } from './styles';
import { Props } from './types';

const FormSectionTitleRenderer: FC<Props> = ({
  name,
  type = FormSectionTitleTypes.primary,
  className,
}) => {
  return (
    <Grid item xs={12}>
      <Title className={className} $type={type}>
        {name}
      </Title>
    </Grid>
  );
};

export default FormSectionTitleRenderer;
